import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import toast from 'react-hot-toast';
import { Plus, Edit2, Trash2 } from 'lucide-react';

const empty = { name:'', description:'', status:1 };

export default function Categories() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get('/categories').then(r => setList(r.data.data || []));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name) return toast.error('Name required');
    try {
      if (editId) await api.put('/categories/' + editId, form);
      else await api.post('/categories', form);
      toast.success('Saved'); setOpen(false); setForm(empty); setEditId(null); load();
    } catch (e) { toast.error(e?.response?.data?.message || 'Error'); }
  };
  const del = async (id) => { if (!window.confirm('Delete?')) return; try { await api.delete('/categories/' + id); toast.success('Deleted'); load(); } catch (e) { toast.error(e?.response?.data?.message || 'Error'); } };
  const edit = (c) => { setForm({...empty, ...c}); setEditId(c.id); setOpen(true); };

  return (
    <div className="card">
      <div className="card-header">
        <h3>Product Categories ({list.length})</h3>
        <button className="btn btn-blue" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }}><Plus size={14}/> Add Category</button>
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Name</th><th>Description</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {list.length ? list.map(c => (
              <tr key={c.id}>
                <td><strong>{c.name}</strong></td>
                <td>{c.description || '-'}</td>
                <td><span className={'badge ' + (c.status == 1 ? 'badge-green' : 'badge-red')}>{c.status == 1 ? 'Active' : 'Inactive'}</span></td>
                <td>
                  <button className="btn btn-sm btn-gray" onClick={()=>edit(c)}><Edit2 size={12}/></button>{' '}
                  <button className="btn btn-sm btn-red" onClick={()=>del(c.id)}><Trash2 size={12}/></button>
                </td>
              </tr>
            )) : <tr><td colSpan="4" className="empty">No categories</td></tr>}
          </tbody>
        </table>
      </div>

      <Modal open={open} onClose={()=>setOpen(false)} title={editId?'Edit Category':'Add Category'}
        footer={<>
          <button className="btn btn-gray" onClick={()=>setOpen(false)}>Cancel</button>
          <button className="btn btn-blue" onClick={save}>{editId?'Update':'Create'}</button>
        </>}>
        <div className="form-grid">
          <div className="form-group full-width"><label>Name *</label><input value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/></div>
          <div className="form-group full-width"><label>Description</label><textarea value={form.description} onChange={e=>setForm({...form, description:e.target.value})}/></div>
          <div className="form-group"><label>Status</label>
            <select value={form.status} onChange={e=>setForm({...form, status:e.target.value})}>
              <option value={1}>Active</option><option value={0}>Inactive</option>
            </select>
          </div>
        </div>
      </Modal>
    </div>
  );
}
